export default __webpack_public_path__ + "static/link-label-do-83e2a9e19ec202e5d39a82fa948ad724c0a88681a46d1ec30f61e8a57754967a.png";